<template>
  <div class="EvaluationFirst"
       id="EvaluationFirst" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.7)"
       element-loading-text="文件正在下载，请稍等" element-loading-spinner="el-icon-loading">
    <div class="evaluateMain">
      <div class="table_panel">
        <span style="font-size:14px;font-weight:600">桥梁结构安全状态等级划分与评定依据</span>
      </div>
      <div class="table">
        <el-table
          :header-cell-style="{background:'#335ABB',color:'#FFF'}"
          stripe
          :data="tableData"
          style="width: 100%;font-size: 14px">
          <el-table-column
            prop="classify"
            label="分类"
            align="center"
            width="180">
          </el-table-column>
          <el-table-column
            prop="eva"
            label="总体评定"
            align="center"
            width="180">
          </el-table-column>
          <el-table-column
            prop="accord"
            align="center"
            label="评定依据">
          </el-table-column>
        </el-table>
        <div class="table_panel">
          <span>注:识别的频率振型和成桥后监测系统首次采集数据得到的相应频率、振型进行比较</span>
        </div>
        <div class="table_panel">
          <span style="margin-right:25%;color:#E68F02;" @click="downloadLeft()">公路桥梁结构安全监测系统技术规程（JT/T 1037-2016）</span>
          <span style="color:#E68F02;" @click="downloadRight()">桥梁结构健康监测系统设计规范（DB32∕T 3562-2019）</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import qs from 'qs'
export default {
  name: 'EvaluationFirst',
  data() {
    return {
      tableData: [{
        classify: '1类',
        eva: '完好状态',
        accord: '结构车辆荷载和抗风的整体安全储备大于2;在设计荷载和监测荷载作用下，所有构件的内力变形均小于规范的设计允许值，不影响结构安全、行车舒适性和耐久性'
      }, {
        classify: '2类',
        eva: '较好状态',
        accord: '结构车辆荷载和抗风的整体安全储备介于1.6～2.0;在设计荷载和监测荷载作用下,关键构件良好,部分次要构件( 10%以内)的内力变形大于规范设计允许值的5% ,但不影响结构安全、行车舒适性和耐久性'
      }, {
        classify: '3类',
        eva: '中等损伤状态',
        accord: '结构车辆荷载和抗风的整体安全储备介于1.6～2.0;在设计荷载和监测荷载作用下,关键构件良好,部分次要构件( 10%以内)的内力变形大于规范设计允许值的5% ,但不影响结构安全、行车舒适性和耐久性'
      }, {
        classify: '4类',
        eva: '严重损伤状态',
        accord: '结构主要频率明显降低;结构车辆荷载和抗风的整体安全储备介于1.2 ~1.4;在设计荷载和监测荷载作用下,部分关键构件(10%以内)内力大于规范设计允许值的10%或关键构件疲劳累计损伤指数0.45～0.80 ,承载能力下降10%以内,影响结构安全性'
      }, {
        classify: '5类',
        eva: '危险状态',
        accord: '结构主要频率明显降低;结构车辆荷载和抗风的整体安全储备介于1.2 ~1.4;在设计荷载和监测荷载作用下,部分关键构件(10%以内)内力大于规范设计允许值的10%或关键构件疲劳累计损伤指数0.45～0.80 ,承载能力下降10%以内,影响结构安全性'
      }],
      loading: false,
    };
  },
  mounted: function () {

  },
  methods: {
    downloadLeft() {
      this.loading = true;
      const req = '公路桥梁结构安全监测系统技术规程-JT∕T 1037-2016'
      this.$axios.get('/api/monitor/safe/downLoadPdf?fileName='+req, {responseType: 'blob'}).then(res => {
          if(!res){
              this.loading = false;
              return
          }
          if(res.data.status==404){
              this.loading = false;
              return
          }
        const _res = res.data;
        if (_res.type == 'application/octet-stream') {
          this.loading = false;
        }
        let blob = new Blob([_res], {type: 'application/pdf;charset=UTF-8'});
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = `公路桥梁结构安全监测系统技术规程-JT∕T 1037-2016.pdf`;
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
        setTimeout(()=>{this.loading = false;},1500)
      })
    },
    downloadRight() {
      this.loading = true;
      const req =  '桥梁结构健康监测系统设计规范-DB32∕T 3562-2019'
      this.$axios.get('/api/monitor/safe/downLoadPdf?fileName='+req, {responseType: 'blob'}).then(res => {
          if(!res){
              this.loading = false;
              return
          }
          if(res.data.status==404){
              this.loading = false;
              return
          }
        const _res = res.data;
        if (_res.type == 'application/octet-stream') {
          this.loading = false;
        }
        let blob = new Blob([_res], {type: 'application/pdf;charset=UTF-8'});
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = `桥梁结构健康监测系统设计规范(DB32∕T 3562-2019).pdf`;
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
          setTimeout(()=>{this.loading = false;},1500)
      })
    }
  }
}
</script>


<style>

    #EvaluationFirst .el-table{
        color: #A7CCF6;
    }

    #EvaluationFirst .el-table__row {
        background-color: #0B3A68 !important;
    }

    #EvaluationFirst .el-table--striped .el-table__body tr.el-table__row--striped td{
        background-color: #021535;
    }

    #EvaluationFirst .el-table td{
        border: unset;
    }

    #EvaluationFirst .el-table th.is-leaf{
        border-bottom: none;
    }

</style>

<style scoped>
    @import url('../../assets/css/style.css');

</style>



// WEBPACK FOOTER //
// src/components/evaluation/EvaluationFirst.vue